import Consignation from './Consignation'
export default Consignation
